import arriereBackoffice from '@avantstay/arriere-clients/dist/arriereBackoffice'

import {
  CompleteDeferredBookingPaymentProps,
  RetryPaymentProps,
  SaveCardProps,
  SetDeferredBookingPaymentAmountProps,
} from '@arriere/types/Payments.types'

// Fragment used for source Type
export const paymentSourceFragment = {
  brand: true,
  kind: true,
  last4: true,
  name: true,
  paymentMethodId: true,
  bankName: {
    bankName: true,
    last4: true,
    chargeId: true,
  },
  link: true,
  linkTargets: {
    contactKind: true,
    value: true,
  },
}

export default {
  async pushBookingToNetsuite(bookingId: string) {
    return arriereBackoffice.mutations.accounting({
      __alias: 'pushBookingToNetsuite',
      pushBookings: {
        __args: {
          bookingsIds: [bookingId],
        },
      },
    })
  },
}

export const getBookingPayments = async (bookingId: string) => {
  return arriereBackoffice.queries
    .booking({
      __alias: 'getBookingPayments',
      __args: {
        bookingId,
      },
      folio: {
        payments: {
          balance: true,
          fake: true,
          amount: true,
          bookingId: true,
          paymentId: true,
          disputes: {
            amount: true,
            id: true,
            operator: {
              internal: true,
              name: true,
            },
            time: true,
            statuses: {
              status: true,
              time: true,
            },
          },
          refunds: {
            amount: true,
            description: true,
            id: true,
            operator: {
              internal: true,
              name: true,
            },
            time: true,
          },
          source: {
            ...paymentSourceFragment,
          },
          statusTrack: {
            operator: {
              internal: true,
              name: true,
            },
            status: true,
            time: true,
          },
          title: true,
        },
      },
    })
    .then(booking => booking?.folio?.payments)
}

export const getAvailableBookingPaymentCards = async (bookingId: string) => {
  return arriereBackoffice.queries.availableBookingPaymentCards({
    __alias: 'getAvailableBookingPaymentCards',
    __args: {
      bookingId,
    },
    id: true,
    customerId: true,
    brand: true,
    last4: true,
    type: true,
    description: true,
    createdAt: true,
  })
}

export const getAvailablePaymentTerminals = async (homeId: string) => {
  return arriereBackoffice.queries.home({
    __alias: 'getAvailableBookingPaymentCards',
    __args: {
      homeId,
    },
    availableReaders: {
      description: true,
      readerId: true,
    },
  })
}

export const getAvailablePaymentBanks = async (bookingId: string) => {
  return arriereBackoffice.queries.availableBookingPaymentBanks({
    __alias: 'getAvailablePaymentBanks',
    __args: {
      bookingId,
    },
    customerId: true,
    bankName: true,
    last4: true,
  })
}

export const saveCreditCardFromTerminal = async ({ bookingId, readerId }: SaveCardProps) => {
  return arriereBackoffice.mutations.booking({
    __alias: 'saveCreditCardFromTerminal',
    initCardSaveInTerminal: {
      __args: { bookingId, readerId },
    },
  })
}

export const deleteSavedCreditCard = async (id: string) => {
  return arriereBackoffice.mutations.payments({
    __alias: 'deleteSavedCreditCard',
    deleteCreditCard: {
      __args: { id },
    },
  })
}

export const completeDeferredBookingPayment = async ({
  paymentId,
  paymentMethod,
}: CompleteDeferredBookingPaymentProps) => {
  return arriereBackoffice.mutations.payments({
    __alias: 'completeDeferredBookingPayment',
    completeDeferredBookingPayment: {
      __args: { paymentId, paymentMethod },
    },
  })
}

export const setDeferredBookingPaymentAmount = async ({
  paymentId,
  amount,
}: SetDeferredBookingPaymentAmountProps) => {
  return arriereBackoffice.mutations
    .payments({
      __alias: 'setDeferredBookingPaymentAmount',
      setDeferredBookingPaymentAmount: {
        __args: { paymentId, amount },
      },
    })
    .then(payments => payments.setDeferredBookingPaymentAmount)
}

export const retryPaymentOnPaymentTerminal = async ({ paymentId, readerId }: RetryPaymentProps) => {
  return arriereBackoffice.mutations.payments({
    __alias: 'retryPaymentOnPaymentTerminal',
    processPaymentOn: {
      __args: { paymentId, readerId },
    },
  })
}
